module.exports = __webpack_public_path__ + "img/106_masterchef.81fddd10.jpg";